import utils from '@/utils';

export default {
  loadStart: ({ state, commit }, key) => {
    commit('loadStart', key);
  },
  loadFinish: ({ state, commit }, key) => {
    commit('loadFinish', key);
  },
};
